module.exports = __webpack_public_path__ + "img/bioritmow.6d3cefd2.png";